/** Small display helpers shared by the Troubleshooting tabs. */

export const formatRelative = (
  iso: string | null | undefined,
  nowMs = Date.now()
): string => {
  if (!iso) return "never";
  const then = new Date(iso).getTime();
  if (!Number.isFinite(then)) return "unknown";
  const diffS = Math.max(0, Math.round((nowMs - then) / 1000));
  if (diffS < 60) return `${diffS} s ago`;
  const diffM = Math.round(diffS / 60);
  if (diffM < 60) return `${diffM} min ago`;
  const diffH = Math.round(diffM / 60);
  if (diffH < 48) return `${diffH} h ago`;
  return `${Math.round(diffH / 24)} d ago`;
};

export const formatDateTime = (iso: string | null | undefined): string => {
  if (!iso) return "—";
  const date = new Date(iso);
  if (!Number.isFinite(date.getTime())) return "—";
  return date.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatBytes = (bytes: number | null | undefined): string => {
  if (bytes == null) return "—";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export const pluralize = (
  count: number,
  singular: string,
  plural = `${singular}s`
) => `${count} ${count === 1 ? singular : plural}`;

/** "554, 80, 8000" → [554, 80, 8000], de-duplicated, capped at 8 valid ports. */
export const parsePortList = (raw: string): number[] =>
  Array.from(
    new Set(
      raw
        .split(/[,\s]+/)
        .map((part) => parseInt(part, 10))
        .filter((port) => Number.isInteger(port) && port > 0 && port < 65536)
    )
  ).slice(0, 8);
